import React from 'react';
import { SingleCommonType } from '../../types';
import { commentsUnderThePostContainingKeywordsIncludedPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect'; 
import './index.scss';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';
import { commentsUnderThePostContainingKeywordsIncludedOptions } from '../../constants/commentsUnderThePostContainingKeywordsIncluded';

export default function CommentsUnderThePostContainingKeywordsIncludedSelect(props: SingleCommonType) {
  return (
    <div className="comments-under-the-post-containing-keywords-included-wrapper">
      <CommonSingleSelect
        {...props}
        returnKey="include_comments_of_matched_posts"
        dealwithReturnValue={(value) => value === "true"}
        singlePlaceholder={commentsUnderThePostContainingKeywordsIncludedPlaceholder}
        options={commentsUnderThePostContainingKeywordsIncludedOptions}
        pointKey={FilterButtonPoint.commentsUnderThePostContainingKeywordsIncluded}
        initValue="false"
      />
    </div>
  );
}
